export default {
  sortByParameter: "price",
  direction: "asc",
};
